window.app = window.app || {};

window.app.backInStock = {
  companyId: 'HS27d3',
  newsletterListId: 'MvQnpg',

  backInStockEndpoint:
    'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=HS27d3',

  newsletterEndpoint:
    'https://a.klaviyo.com/client/subscriptions/?company_id=HS27d3',

  init: function () {
    const form = document.querySelector('.klaviyo-bis');
    if (!form) return;

    this.prepareInterface(form);
    this.bindSubmit(form);
  },

  prepareInterface: function (form) {
    const signupStep = form.querySelector('.klaviyo-bis__step--signup');
    if (!signupStep) return;

    let trigger = form.querySelector('.klaviyo-bis__trigger');

    if (!trigger) {
      trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className =
        'klaviyo-bis__trigger button button--full-width button--outline';
const isPolish = (
  document.documentElement.lang || ''
).toLowerCase().startsWith('pl');

trigger.textContent = isPolish
  ? 'Powiadom o dostępności'
  : 'Notify me when available';

      form.insertBefore(trigger, signupStep);

      trigger.addEventListener('click', () => {
        trigger.hidden = true;
        signupStep.classList.remove('klaviyo-bis__step--collapsed');

        const emailInput = signupStep.querySelector('input[name="email"]');

        if (emailInput) {
          setTimeout(() => emailInput.focus(), 100);
        }
      });
    }

    signupStep.classList.add('klaviyo-bis__step--collapsed');
    trigger.hidden = false;

    this.addNewsletterCheckbox(signupStep);
  },

  addNewsletterCheckbox: function (signupStep) {
    if (
      signupStep.querySelector('.klaviyo-bis__newsletter-consent')
    ) {
      return;
    }

    const submitButton = signupStep.querySelector(
      'button[type="submit"], input[type="submit"]'
    );

    if (!submitButton) return;

    const consent = document.createElement('label');
    consent.className = 'klaviyo-bis__newsletter-consent';

const isPolish = (
  document.documentElement.lang || ''
).toLowerCase().startsWith('pl');

const consentText = isPolish
  ? 'Zapisz mnie również do newslettera'
  : 'I would also like to sign up for the newsletter';

consent.innerHTML = `
  <input type="checkbox" name="newsletter_consent">
  <span>${consentText}</span>
`;
    submitButton.parentNode.insertBefore(consent, submitButton);
  },

  bindSubmit: function (form) {
    if (form.dataset.bisSubmitBound === 'true') return;

    form.dataset.bisSubmitBound = 'true';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const emailInput = form.querySelector('input[name="email"]');
      const variantInput = form.querySelector('input[name="variant"]');
      const newsletterConsent = form.querySelector(
        'input[name="newsletter_consent"]'
      );

      const error = form.querySelector('.klaviyo-bis__error');
      const signupStep = form.querySelector(
        '.klaviyo-bis__step--signup'
      );
      const successStep = form.querySelector(
        '.klaviyo-bis__step--success'
      );
      const trigger = form.querySelector('.klaviyo-bis__trigger');

      if (!emailInput || !variantInput || !emailInput.value) return;

      if (error) {
        error.classList.add('hidden');
      }

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
attributes: {
  email: emailInput.value
}
              }
            },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantInput.value}`
              }
            }
          }
        }
      };

      try {
        const response = await fetch(this.backInStockEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2026-04-15'
          },
          body: JSON.stringify(payload)
        });

        if (response.status !== 202) {
          throw new Error('Back in stock subscription failed');
        }

        if (newsletterConsent && newsletterConsent.checked) {
          await this.subscribeToNewsletter(emailInput.value);
        }

        if (signupStep) {
          signupStep.classList.add(
            'klaviyo-bis__step--collapsed'
          );
        }

        if (trigger) {
          trigger.hidden = true;
        }

        if (successStep) {
          successStep.classList.remove('hidden');
        }
      } catch (requestError) {
        if (error) {
          error.classList.remove('hidden');
        }
      }
    });
  },

  subscribeToNewsletter: function (email) {
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          },
          custom_source: 'Powiadomienie o dostępności'
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: this.newsletterListId
            }
          }
        }
      }
    };

    return fetch(this.newsletterEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2026-04-15'
      },
      body: JSON.stringify(payload)
    });
  },

  reset: function () {
    const form = document.querySelector('.klaviyo-bis');
    if (!form) return;

    const trigger = form.querySelector('.klaviyo-bis__trigger');
    const signupStep = form.querySelector(
      '.klaviyo-bis__step--signup'
    );
    const successStep = form.querySelector(
      '.klaviyo-bis__step--success'
    );

    if (trigger) {
      trigger.hidden = false;
    }

    if (signupStep) {
      signupStep.classList.add('klaviyo-bis__step--collapsed');
    }

    if (successStep) {
      successStep.classList.add('hidden');
    }
  },

  setupMutationObserver: function () {
    const target = document.querySelector(
      '.product__info-container'
    );

    if (!target) return;

    const observer = new MutationObserver(() => {
      this.init();
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  },

  setupVariantListener: function () {
    document.addEventListener('change', (event) => {
      if (
        !event.target.closest(
          'variant-radios, variant-selects'
        )
      ) {
        return;
      }

      setTimeout(() => {
        this.init();
        this.reset();
      }, 150);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  window.app.backInStock.setupMutationObserver();
  window.app.backInStock.setupVariantListener();
  window.app.backInStock.init();
});